import { PickingListAllocationsReport } from './picking-list-allocations-report';

export interface PickingListReportLine {
  productKey: string;
  productDescription: string;
  productOldCode: string;
  makeUp: string;
  customerProduct: string;
  productType: string;
  holdStockAtProductLevel: boolean;
  customerLineRef: string;
  orderLineNotes: string;
  quantity: number;
  quantityString: string;
  price: number;
  priceString: string;
  discount: number;
  value: number;
  valueString: string;
  unit: string;
  priceListUnit: string;
  deliveryDate: Date;
  deliveryDateString: string;
  deliveryNotes: string;
  notes: string;
  warehouse: string;
  location: string;
  currencySymbol: string;
  pickingListAllocations: PickingListAllocationsReport[];
}
